<div #chatIcon class="cs-private-chat-icon">
    <img class="logo" src="{{ mediaServer }}/zeta/home/chat/icon_chatlist-cs.png" alt="" (click)="onCsChatIconClick()">
</div>